


































import { Component } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IActiveMqClientConfiguration } from "sitewhere-configuration-model";
import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogForm, FormText },
  validations: {
    remoteUri: {
      required
    },
    queueName: {
      required
    },
    numConsumers: {
      required
    }
  }
})
export default class ActiveMqClientFields extends DialogSection {
  remoteUri = "";
  queueName = "sitewhere";
  numConsumers = 3;

  /** Reset section content */
  reset(): void {
    this.remoteUri = "";
    this.queueName = "sitewhere";
    this.numConsumers = 3;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IActiveMqClientConfiguration): void {
    this.remoteUri = input.remoteUri || "";
    this.queueName = input.queueName || "sitewhere";
    this.numConsumers = input.numConsumers || 3;
  }

  /** Save form data to an object */
  save(): {} {
    return {
      remoteUri: this.remoteUri,
      queueName: this.queueName,
      numConsumers: this.numConsumers
    };
  }
}
